import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { BlockTitleComponent } from "./block-title.component";
import { BlockTitleEditorModule } from '../block-title-editor/block-title-editor.module';
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {IconNameToDefinitionModule} from "../../../pipes/icon-name-to-definition/icon-name-to-definition.module";

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        BlockTitleEditorModule,
        MatTooltipModule,
        FontAwesomeModule,
        IconNameToDefinitionModule,
    ],
    exports: [
        BlockTitleComponent,
    ],
    declarations: [
        BlockTitleComponent,
    ],
})
export class BlockTitleModule {
}
